import React from "react";
import "../Styles/about.css"; 


const About = () => {
  return (
    <section className="about-page">
      <div className="container">
        {/* HERO SECTION */}
        <div className="hero-section">
          {/* === Add your image here === */}
          <img src="/Images/Website Background.png" alt="DJ TLynn" className="dj-image" />
          <div className="hero-text">
            <h1>DJ TLynn</h1>
            <p className="tagline">Multigenre DJ | Curator of Global Vibes</p>
            <p className="intro">
              Based in Austin, Texas — DJ TLynn is a multigenre DJ known for
              blending Dancehall, Hip-Hop, Afrobeats, and R&B into high-energy,
              cross-cultural experiences that bring people together through
              rhythm and sound.
            </p>
          </div>
        </div>

        {/* JOURNEY SECTION */}
        <div className="journey">
          <h2>My Journey</h2>
          <p>
            My story with music began long before I ever stepped behind the
            turntables. As a lifelong lover of rhythm and culture, I found
            myself drawn to the way music connects people — no matter where
            they’re from. After moving to Austin, I started playing at local
            events, quickly earning recognition for my ability to read the room
            and take crowds on a musical journey across genres.
          </p>
          <p>
            My sets are inspired by the energy of the African and Caribbean
            diaspora, infused with the soul of Hip-Hop and the feel-good essence
            of R&B. What started as a passion project has evolved into a
            platform — bringing together communities through shared vibes,
            movement, and celebration.
          </p>
          <p>
  Over time, I’ve made it a priority to study and understand the
  sounds, languages, and cultural rhythms that make each crowd unique.
  Whether it’s Afrobeats from Lagos, Dancehall from Kingston, Soca from
  Trinidad, or Hip-Hop from Atlanta, I’ve taken time to learn how
  each genre moves people. This commitment to learning and cultural
  respect allows me to truly be an <strong>open-format DJ</strong> —
  someone who can seamlessly connect different worlds through music and
  make every audience feel seen and celebrated.
</p>
        </div>

        {/* FEATURE GRID */}
        <div className="features">
          <h2>Featured In</h2>
          <div className="feature-grid">
            <a
              href="https://voyagesanantonio.com/interview/rising-stars-meet-dj-tlynn-of-austin-texas/"
              target="_blank"
              rel="noopener noreferrer"
              className="feature-card"
            >
              <h3>Voyage San Antonio</h3>
              <p>Rising Stars Interview</p>
            </a>

            <a
              href="https://canvasrebel.com/meet-dj-tlynn/"
              target="_blank"
              rel="noopener noreferrer"
              className="feature-card"
            >
              <h3>Canvas Rebel</h3>
              <p>Artist Spotlight</p>
            </a>

            <a
              href="https://boldjourney.com/meet-dj-tlynn/"
              target="_blank"
              rel="noopener noreferrer"
              className="feature-card"
            >
              <h3>Bold Journey</h3>
              <p>Behind the Mix Feature</p>
            </a>
          </div>
        </div>

        {/* CULTURE SECTION */}
        <div className="culture">
          <h2>Culture & Vibes</h2>
            <p>
    Every set I play is a story — a journey through sound, rhythm, and emotion. 
    I’m passionate about representing culture and creating spaces where everyone feels the beat, 
    whether it’s at a brunch, club, or festival.
  </p>
  <p>
    Over time, I’ve dedicated myself to learning and understanding different musical cultures — 
    from the pulse of Afrobeats and dancehall to the bounce of hip-hop and R&B. 
    Being able to perform for diverse crowds means knowing how to blend genres 
    in ways that honor their origins while keeping the dance floor connected. 
    That’s what being an open-format DJ truly means to me — not just playing everything, 
    but knowing *why* each sound moves people the way it does.
  </p>
  <p>
    My events — like <strong>True Mashup</strong> — celebrate African, Caribbean, and Black American influences, 
    blending them into one unforgettable experience where rhythm, culture, and community collide.
  </p>
        </div>

        {/* CTA FOOTER */}
        <div className="cta-footer">
          <p>
            Let’s create moments that move people. <br />
            <a href="/booking" className="cta-link">
              Book DJ TLynn
            </a>
          </p>
        </div>
        <footer className="footer">
        <div className="footer-inner">
          <div className="footer-columns">
            {/* Brand */}
            <div className="footer-col">
              <h3>DJ TLynn</h3>
              <p>Offering professional DJ services for unforgettable events and experiences. International DJ, DJ TLynn, speacializes in genres of Dancehall, Afrobeats, Hip-Hop and more.</p>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4>Quick Links</h4>
              <a href="/">Home</a>
              <a href="/social">Social Media</a>
              <a href="/booking">Booking</a>
              <a href="/about">About</a>
            </div>

            {/* Get In Touch */}
            <div className="footer-col">
              <h4>Get In Touch</h4>
              <p>
                <a href="tel:+15126750427" className="footer-phone" style={{color: '#fff', textDecoration: 'underline', transition: 'color 0.2s'}}>+1 (512) 815-3169</a>
              </p>
              <p>
                <span role="img" aria-label="Email"></span> <a href="mailto:bookings@djtlynn.com" className="footer-email" style={{verticalAlign: 'middle'}}>bookings@djtlynn.com</a>
              </p>
              <p>📍 Available Nationwide (Based: Austin Texas)</p>
            </div>
          </div>

          {/* Socials */}
          <div className="social-row">
            <a href="https://www.instagram.com/dj.tlynn/" aria-label="Instagram" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
              </svg>
              <span className="social-label">Instagram</span>
            </a>
            <a href="https://www.youtube.com/@DJTlynn" aria-label="YouTube" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                <rect x="2" y="4" width="20" height="16" rx="4" ry="4" />
                <polygon points="10 9 16 12 10 15 10 9" fill="currentColor" />
              </svg>
              <span className="social-label">YouTube</span>
            </a>
            <a href="https://www.tiktok.com/@dj.tlynn" aria-label="TikTok" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                <path d="M9 17a4 4 0 1 1 0-8v8zm0 0V7.5A4.5 4.5 0 0 1 13.5 3H15v3.5A4.5 4.5 0 0 0 19.5 11H21" />
              </svg>
              <span className="social-label">TikTok</span>
            </a>
          </div>

          <div className="copyright">
            <p>© 2025 DJ TLynn. All rights reserved.</p>
          </div>
        </div>
      </footer>
      </div>
    </section>
  );
};

export default About;